import MaydayLogsClient from '@getmayday/mayday-logs-client'
import { TokenService } from '@getmayday/mayday-api-instances'
import { useAdminStore } from '@getmayday/vue-modules'
import prepareAxios from './axios'

import { Pinia } from 'pinia'

// const isProduction = process.env.NODE_ENV === 'production';

export const prepareClients = (pinia: Pinia) => {
  const tokenService = new TokenService(
    () => {
      const adminStore = useAdminStore(pinia)
      return adminStore.accessToken || ''
    },
    () => {
      // TODO
      return ''
    },
    () => {
      return new Promise((resolve) => {
        const configStore = useConfigStore()

        configStore.logout()
        resolve('Logout successful')
      })
    }
  )

  const { adminClient, authClient, knowledgeClient, notificationClient, brainClient, eventClient } =
    prepareAxios(tokenService)

  const logClient = new MaydayLogsClient({
    origin: 'CHROME_EXTENSION',
    lenient: false,
    axiosClient: eventClient as any,
    clientIsConfig: true
  })

  return {
    adminClient,
    authClient,
    knowledgeClient,
    notificationClient,
    brainClient,
    logClient
  }
}
